var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { Link } from "react-router-dom";
import ProfileIcon from "../ProfileIcon";
import SaveTag from "../SaveTag";
import formatPublishedDate from "../../../utils/formatPublishedDate";

import styles from "./StoryHeader.css";

var StoryHeader = function (_Component) {
  _inherits(StoryHeader, _Component);

  function StoryHeader() {
    _classCallCheck(this, StoryHeader);

    return _possibleConstructorReturn(this, (StoryHeader.__proto__ || Object.getPrototypeOf(StoryHeader)).apply(this, arguments));
  }

  _createClass(StoryHeader, [{
    key: "render",
    value: function render() {
      var story = this.props.story;
      if (!story) return null;
      return React.createElement(
        "div",
        { className: styles.root },
        React.createElement(
          "div",
          { className: styles.profile },
          story.byline_photo ? React.createElement("img", { src: story.byline_photo, alt: "Profile photo", className: styles.bylinePhoto }) : React.createElement(ProfileIcon, { className: styles.icon }),
          React.createElement(
            "div",
            null,
            story.authors && story.authors.map(function (author, index) {
              return React.createElement(
                Link,
                { key: author.username, to: "/authors/" + author.username, className: styles.author },
                author.display_name,
                index < story.authors.length - 1 && ", "
              );
            }),
            " ",
            React.createElement(
              "span",
              { className: styles.date },
              formatPublishedDate(story)
            )
          )
        ),
        React.createElement(SaveTag, { storyId: story.id })
      );
    }
  }]);

  return StoryHeader;
}(Component);

export default StoryHeader;


// WEBPACK FOOTER //
// ./src/components/Library/StoryHeader/StoryHeader.js